export const ALL_EVENTS = 'All Events';
export const ALL_EVENTS_VALUE = '_ALL_';
